// import React, { Suspense, lazy } from "react";
// import { connect } from "react-redux";
// import { Navigate, Route, Routes } from "react-router-dom";
// import AsyncRoute from "./AsyncRoute";
// import PageNotFound from "../screens/PageNotFound/PageNotFound";
// import AuthenticatedLayout from "../Layout/AuthenticatedLayout";
// import { getUserByToken } from "../Actions/UserAction";

// const getCommonRoutes = (url) => [
//   {
//     path: `${url}/contactus`,
//     screen: lazy(() => import("../screens/Admin/Contactus")),
//   },
//   {
//     path: `${url}/volunteers`,
//     screen: lazy(() => import("../screens/Admin/Volunteers")),
//   },
//   {
//     path: `${url}/subscribers`,
//     screen: lazy(() => import("../screens/Admin/Subscribers")),
//   },
//   {
//     path: `${url}/events`,
//     screen: lazy(() => import("../screens/Admin/Events/Events")),
//   },
//   {
//     path: `${url}/events/add`,
//     screen: lazy(() => import("../screens/Admin/Events/EventsForm")),
//   },
//   {
//     path: `${url}/events/update/:eventId`,
//     screen: lazy(() => import("../screens/Admin/Events/EventsForm")),
//   },
//   {
//     path: `${url}/abstracts`,
//     screen: lazy(() => import("../screens/Admin/Abstract")),
//   },
// ];

// class AuthenticatedRoutes extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       loader: !props.userInfo,
//     };
//   }

//   componentDidMount() {
//     if (localStorage.getItem("PHARMA_SOS_USER")) {
//       this.props
//         .dispatch(getUserByToken(localStorage.getItem("PHARMA_SOS_USER")))
//         .then(() => {
//           this.setState({ loader: false });
//         });
//     }
//   }

//   render() {
//     const {
//       match: { url },
//     } = this.props;

//     const currentUser = localStorage.getItem("PHARMA_SOS_USER");

//     if (!currentUser) {
//       return <Navigate to="/" />;
//     }

//     if (this.state.loader) {
//       return <div>Loading..</div>;
//     }

//     return (
//       <Suspense fallback={<center>Loading..</center>}>
//         <AuthenticatedLayout {...this.props}>
//           <Routes>
//             {getCommonRoutes(url).map(({ path, access, ...restProps }) => (
//               <Route
//                 key={path}
//                 exact
//                 path={path}
//                 render={(props) => <AsyncRoute {...props} {...restProps} />}
//               />
//             ))}

//             <Route component={PageNotFound} />
//           </Routes>
//         </AuthenticatedLayout>
//       </Suspense>
//     );
//   }
// }

// export default connect()(AuthenticatedRoutes);

import { Suspense, lazy, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { getUserByToken } from "../Actions/UserAction";
import AuthenticatedLayout from "../Layout/AuthenticatedLayout"; 
import PageNotFound from "../screens/PageNotFound/PageNotFound";

const getCommonRoutes = () => [
  {
    path: "contactus",
    screen: lazy(() => import("../screens/Admin/Contactus")),
  },
  {
    path: "volunteers",
    screen: lazy(() => import("../screens/Admin/Volunteers")),
  },
  {
    path: "subscribers",
    screen: lazy(() => import("../screens/Admin/Subscribers")),
  },
  {
    path: "events",
    screen: lazy(() => import("../screens/Admin/Events/Events")),
  },
  {
    path: "speakers",
    screen: lazy(() => import("../screens/Admin/Speakers")),
  },
  {
    path: "events/add",
    screen: lazy(() => import("../screens/Admin/Events/EventsForm")),
  },
  {
    path: "events/update/:eventId",
    screen: lazy(() => import("../screens/Admin/Events/EventsForm")),
  },
  {
    path: "abstracts",
    screen: lazy(() => import("../screens/Admin/Abstract")),
  },
  {
    path: "gallery",
    screen: lazy(() => import("../screens/Admin/Gallery/Gallery")),
  },
];

const AuthenticatedRoutes = (props) => {
  const [loader, setLoader] = useState(!props.userInfo);

  useEffect(() => {
    if (localStorage.getItem("PHARMA_SOS_USER")) {
      props
        .dispatch(getUserByToken(localStorage.getItem("PHARMA_SOS_USER")))
        .then(() => {
          setLoader(false);
        });
    }
  }, [props]);

  const currentUser = localStorage.getItem("PHARMA_SOS_USER");

  if (!currentUser) {
    return <Navigate to="/" />;
  }

  if (loader) {
    return <div>Loading..</div>;
  }

  return (
    <Suspense fallback={<center>Loading..</center>}>
      <AuthenticatedLayout {...props}>
        <Routes>
          {getCommonRoutes().map(
            ({ path, screen: Component, ...restProps }) => (
              <Route
                key={path}
                path={path}
                element={<Component {...restProps} />}
              />
            )
          )}

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </AuthenticatedLayout>
    </Suspense>
  );
};

export default connect()(AuthenticatedRoutes);
